// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2udix","question":"styles_question__1euwN","description":"styles_description__5Plvl"};